/**
 * Display version shown in the Tournament Builder footer.
 * Update when switching release branches:
 *   feature/summer-26.0  →  Summer 26.0
 *   feature/spring-1.0.1 →  Spring 1.0.1
 */
export const APP_VERSION = 'Summer 26.0';
